<template>
  <PageLayout>
    <template slot="header">
      <div class="d-flex m-3 mx-lg-0">
        <Breadcrumb :list="breadcrumbList" />
      </div>
      <MainNavbar />
    </template>
    <template slot="main">
      <b-card>
        <b-form @submit.prevent="save">
          <h5 class="section-header">
            {{ resources.page.home.users.edit.informations }}
            <div class="float-right user-status">
              <span
                v-if="
                  selectedUser.inactive && selectedUser.status !== 'deactivated'
                "
                class="status inactive"
              >
                <small>{{ resources.page.home.users.type.inactivated }}</small>
              </span>
              <span
                v-else-if="
                  selectedUser.status === 'unconfirmed' &&
                    !selectedUser.inactive
                "
                class="status invited"
              >
                <small>{{ resources.page.home.users.type.unconfirmed }}</small>
              </span>
              <span
                v-else-if="selectedUser.status === 'deactivated'"
                class="status deactivated"
              >
                <small>{{ resources.page.home.users.type.deactivated }}</small>
              </span>
              <span
                v-else-if="
                  selectedUser.status === 'confirmed' && !selectedUser.inactive
                "
                class="status confirmed"
              >
                <small>{{ resources.page.home.users.type.confirmed }}</small>
              </span>
            </div>
          </h5>
          <b-row class="pt-3">
            <b-col cols="12" xl="6">
              <CustomInput
                :label="resources.general.input.firstName"
                :title="resources.general.input.textWarning"
                v-model="selectedUser.profile.firstname"
                :labelWrong="resources.general.input.firstNameWrong"
              >
              </CustomInput>
            </b-col>
            <b-col cols="12" xl="6">
              <CustomInput
                :label="resources.general.input.lastName"
                :title="resources.general.input.textWarning"
                v-model="selectedUser.profile.lastname"
                :labelWrong="resources.general.input.firstNameWrong"
              >
              </CustomInput>
            </b-col>
            <b-col cols="12" xl="6">
              <CustomEmail
                :label="resources.general.input.emailTitle"
                :isValid="true"
                :initialValue="selectedUser.email"
                :disabled="true"
                inputId="email"
              />
            </b-col>
            <b-col cols="12" xl="6" class="email-select">
              <b-form-group>
                <b-form-select
                  size="lg"
                  required
                  id="role"
                  v-model="selectedUser.role"
                >
                  <option value="admin">
                    {{ resources.general.input.roles.admin }}
                  </option>
                  <option value="manager">
                    {{ resources.general.input.roles.manager }}
                  </option>
                  <option value="user">
                    {{ resources.general.input.roles.user }}
                  </option>
                </b-form-select>
                <label class="custom-input-label">
                  {{ resources.general.input.role }}
                </label>
                <label class="mdi mdi-chevron-down select-icon"></label>
              </b-form-group>
            </b-col>
            <b-col cols="12" xl="6" v-if="selectedUser.code">
              <CustomInput
                :label="resources.page.home.users.edit.code"
                :value="selectedUser.code"
                :disabled="true"
              />
            </b-col>
            <b-col cols="12" xl="6">
              <CustomInput
                name="date"
                :isRequired="false"
                :hasMask="true"
                :label="resources.page.home.users.edit.birthDate"
                :value="formatBirthDate(selectedUser.birthDate)"
                @update="updateBirthDate($event.value)"
              />
            </b-col>
          </b-row>
          <h5
            class="section-header mt-3"
            v-if="userAttributesLoading || userAttributes.length > 0"
          >
            {{ resources.page.home.users.edit.attributes }}
          </h5>
          <b-row class="pt-3" v-if="userAttributesLoading">
            <b-col class="filter-select-item">
              {{ labels.userAttributesLoading }}
            </b-col>
          </b-row>
          <b-row class="pt-4" v-else>
            <b-col
              required
              class="filter-select-item"
              v-for="userAttribute in userAttributes"
              :key="`user-attribute-${userAttribute.id}`"
              cols="12"
              xl="6"
            >
              <label class="custom-input-label">
                {{ userAttribute.label }}
              </label>
              <treeselect
                ref="treeselect"
                name="user-attributes-select"
                :placeholder="labels.select"
                :clearAllText="labels.cleanSelect"
                :options="userAttribute.values"
                :multiple="multiple"
                :clearable="clearable"
                :searchable="searchable"
                :open-on-click="openOnClick"
                :open-on-focus="openOnFocus"
                :close-on-select="closeOnSelect"
                :always-open="alwaysOpen"
                @input="updateUserAttribute($event, userAttribute.id)"
                :value="
                  selectedUser.attributes
                    .filter(a => a.key === userAttribute.id)
                    .map(a => a.value)
                "
              >
              </treeselect>
            </b-col>
          </b-row>
          <h5
            class="section-header mt-2"
            v-if="
              (selectedUser.managers && selectedUser.managers.length > 0) ||
                membersOfGroups.length > 0 ||
                membersOfSmartGroups.length > 0
            "
          >
            {{ resources.page.home.users.edit.groups }}
          </h5>
          <b-row
            class="pb-3"
            v-if="selectedUser.managers && selectedUser.managers.length > 0"
          >
            <b-col>
              <h6>{{ resources.page.home.users.edit.manager }}</h6>
              <b-row
                v-for="manager in selectedUser.managers"
                :key="manager.key"
              >
                <b-col>
                  <b-link
                    :to="{
                      name: 'dashboard.groups',
                      params: { groupId: manager._id },
                    }"
                  >
                    {{ manager.name }}
                  </b-link>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="pb-3" v-if="membersOfGroups.length > 0">
            <b-col>
              <h6>{{ resources.page.home.users.edit.member }}</h6>
              <b-row v-for="member in membersOfGroups" :key="member.key">
                <b-col>
                  <b-link
                    :to="{
                      name: 'dashboard.groups',
                      params: { groupId: member._id },
                    }"
                  >
                    {{ member.name }}
                  </b-link>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="pb-3" v-if="membersOfSmartGroups.length > 0">
            <b-col>
              <h6>{{ resources.page.home.users.edit.smartGroup }}</h6>
              <b-row v-for="member in membersOfSmartGroups" :key="member.key">
                <b-col>
                  <b-link
                    :to="{
                      name: 'dashboard.groups',
                      params: { groupId: member._id },
                    }"
                  >
                    {{ member.name }}
                  </b-link>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-list-group flush class="pt-4" v-if="!$can('access', 'read-only')">
            <b-list-group-item>
              <b-row align-h="end">
                <b-button
                  style="max-width:200px"
                  id="btn-save"
                  v-on:keyup.enter="submit"
                  :disabled="saving"
                  type="submit"
                  variant="primary"
                  class="col-12 mt-3"
                >
                  <i
                    class="mdi mdi-spin pr-2"
                    v-bind:class="{ 'mdi-loading': saving }"
                  ></i
                  >{{ resources.page.home.users.edit.save }}
                </b-button>
              </b-row>
            </b-list-group-item>
          </b-list-group>
        </b-form>
      </b-card>
    </template>
  </PageLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomInput from '@/components/Shared/Form/CustomInput.vue'
import CustomEmail from '@/components/Shared/Form/CustomEmail.vue'
import PageLayout from '@/components/Home/PageLayout.vue'
import { HIGH } from '@/helpers/messages-priority'
import Breadcrumb from '@/components/Shared/Breadcrumb.vue'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { isBasicPlan } from '@/service/user'
import MainNavbar from '@/components/Management/MainNavbar'

export default {
  mounted() {
    this.$root.$emit('setPageTitle', { context: this, path: 'users/edit' })
  },
  components: {
    CustomInput,
    CustomEmail,
    PageLayout,
    Breadcrumb,
    Treeselect,
    MainNavbar,
  },

  async created() {
    if (this.user) {
      this.selectedUser = JSON.parse(JSON.stringify(this.user))

      if (!this.selectedUser.attributes) {
        this.selectedUser.attributes = []
      }

      this.sortGroups({ groups: this.selectedUser.managers })
      this.sortGroups({ groups: this.selectedUser.members })

      if (!this.isBasicPlan) {
        await this.$store.dispatch('userAttributes/loadUserAttributesFilter')

        const attributes = this.selectedUser.attributes
        this.selectedUser.attributes = this.translateUserAttributes(attributes)
      }
    } else {
      this.$router.push({ name: 'dashboard.users' })
    }
  },

  data() {
    return {
      selectedUser: { profile: {} },
      submitInProgress: false,
      saving: false,
      multiple: true,
      clearable: true,
      searchable: false,
      openOnClick: true,
      openOnFocus: true,
      closeOnSelect: true,
      alwaysOpen: false,
    }
  },

  computed: {
    ...mapGetters({
      resources: 'resources',
      user: 'users/selectedUser',
      userAttributes: 'userAttributes/filterUserAttributes',
      userAttributesLoading: 'userAttributes/filterLoading',
    }),
    breadcrumbList() {
      return [
        {
          label: this.resources.general.menu.settings,
        },
      ]
    },
    membersOfSmartGroups() {
      return this.selectedUser.members &&
        this.selectedUser.members.length > 0 &&
        this.selectedUser.members.find(g => g.smartGroup)
        ? this.selectedUser.members.filter(g => g.smartGroup)
        : []
    },
    membersOfGroups() {
      return this.selectedUser.members &&
        this.selectedUser.members.length > 0 &&
        this.selectedUser.members.find(g => !g.smartGroup)
        ? this.selectedUser.members.filter(g => !g.smartGroup)
        : []
    },
    labels() {
      return this.resources.page.invite
    },
    // @TODO copy from UserImporter
    userAttributesMap() {
      const userAttributes = this.userAttributes
      const userAttributesMap = {}
      userAttributes.forEach(userAttribute => {
        userAttributesMap[userAttribute.label] = {
          id: userAttribute.id,
          values: userAttribute.values.reduce((map, item) => {
            map[item.label] = item.id
            return map
          }, {}),
        }
      })
      return userAttributesMap
    },
    isBasicPlan() {
      return isBasicPlan()
    },
  },
  methods: {
    translateUserAttributes(userAttributes) {
      const userAttributesMap = this.userAttributesMap
      return userAttributes.reduce((list, item) => {
        const userAttributeRef = userAttributesMap[item.key]
        if (userAttributeRef) {
          const value = userAttributeRef.values[item.value]
          list.push({ key: userAttributeRef.id, value })
        }
        return list
      }, [])
    },
    updateBirthDate(date) {
      if (!date || date === '') {
        this.selectedUser.birthDate = null
        return
      }

      const i = date.split('/')
      this.selectedUser.birthDate =
        i.length === 3 ? `${i[2]}-${i[1]}-${i[0]}` : date
    },
    formatBirthDate(date) {
      if (!date) {
        return null
      }
      const i = date.split('-')
      return i.length === 3 ? `${i[2]}/${i[1]}/${i[0]}` : date
    },
    sortGroups({ groups = false }) {
      if (!groups) return []
      groups.sort(({ name: a }, { name: b }) => a.localeCompare(b))
    },
    save() {
      this.saving = true
      this.$store
        .dispatch('users/update', this.selectedUser)
        .then(() => {
          this.saving = false
          this.$root.$emit('app:message:show', {
            priority: HIGH,
            text: this.resources.page.home.users.edit.saveWithSuccessMessage,
            status: 'success',
          })
          this.$router.push({ name: 'dashboard.users' })
        })
        .catch(() => {
          this.saving = false
          this.$root.$emit('app:message:show', {
            priority: HIGH,
            text: this.resources.page.home.users.edit.errorMessage,
            status: 'danger',
          })
        })
    },
    updateFormProfile(property, e) {
      this.selectedUser.profile[property] = e.value
    },
    updateUserAttribute(values, key) {
      const attributes = this.selectedUser.attributes.filter(a => a.key !== key)
      attributes.push(...values.map(value => ({ key, value })))
      this.selectedUser.attributes = attributes
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.section-header {
  color: map-get($theme-colors, 'primary');
  border-bottom: 1px solid map-get($theme-colors, 'gray00');
}

.email-select {
  padding-bottom: 20px;
}

.user-status {
  font-weight: 500;
  font-size: 16px;

  .status {
    &.invited {
      color: map-get($theme-colors, 'orange');
    }

    &.confirmed {
      color: map-get($theme-colors, 'green-dark');
    }

    &.deactivated {
      color: map-get($theme-colors, 'gray02');
    }

    &.inactive {
      color: map-get($theme-colors, 'gray03');
    }
  }
}

.filter-select-item {
  margin-bottom: 35px;

  .custom-input-label {
    color: map-get($theme-colors, 'primary') !important;
    font-size: 12px;
    top: -18px;
    left: 40px !important;
  }

  /deep/ .vue-treeselect {
    .vue-treeselect__menu {
      border-radius: 30px !important;
      overflow-x: auto;
    }

    .vue-treeselect__checkbox--checked {
      border-color: map-get($theme-colors, 'primary') !important;
      background: map-get($theme-colors, 'primary') !important;
    }

    .vue-treeselect__control {
      border-radius: 30px !important;
      height: 48px;
    }

    .vue-treeselect__placeholder {
      margin: 7px;
      font-size: 10pt;
    }

    .vue-treeselect__multi-value-item {
      border-radius: 30px !important;
      background-color: map-get($theme-colors, 'gray08');
      color: map-get($theme-colors, 'primary') !important;

      .vue-treeselect__value-remove {
        color: map-get($theme-colors, 'primary') !important;
      }

      .vue-treeselect__multi-value-label {
        white-space: normal;
      }
    }

    .vue-treeselect__label-container {
      &:hover {
        .vue-treeselect__checkbox--unchecked {
          border-color: map-get($theme-colors, 'primary');
        }
      }

      .vue-treeselect__label {
        overflow: inherit;
      }
    }

    .vue-treeselect__option--selected {
      background-color: map-get($theme-colors, 'gray08');
    }
  }
}
</style>
